import React, { useEffect, useState } from "react";
import CgFormCreator from "../../common/CgFormCreator";
import "./login.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLoginUserDetails,
  fetchProviderAuthenticateWhileLogin,
  fetchUpdatePassword,
} from "../../store/Login/LoginActions";
import PinVerification from "./PinVerification";
import alertIcon from "../../assets/Icons/ic-alert-red.svg";
import Mfa from "./Mfa";
import FloatingLabelInput from "./FloatingLabelInput";
import providerTerms from "../../assets/pdf/providerTerms.pdf";
import Practice013x from "../../assets/Icons/Practice-01@3x.svg";
import brighter from "../../assets/Icons/brighter.svg";
import cignaLogo from "../../assets/Icons/cigna-logo.svg";
import downwardArrow from "../../assets/Icons/downward-arrow.svg";
import whiteChat from "../../assets/Icons/whtBlue-chat.svg";
import whiteLock from "../../assets/Icons/whtBlue-lock.svg";

const LoginFirst = () => {
  const [isLogin, setIsLogin] = useState("create");
  const [userName, setUserName] = useState("");
  const [isConfirmed, setIsConfirmed] = useState();
  const [loginDetails, setLoginDetails] = useState();
  const [isAlreadyHaveAccount, setIsAlreadyHaveAccount] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showError, setShowError] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showUsernameError, setShowUsernameError] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [loginPassword, setLoginPassword] = useState("");
  const [formKey, setFormKey] = useState(Date.now());
  const dispatch = useDispatch();
  const navigateTo = useNavigate();
  const location = useLocation();
  const locationData = location.pathname.split("/");

  console.log(userName == "1" && loginPassword);

  const { providerLoginAuth, providerLoginSectionError } = useSelector(
    (state) => state.loginAuth
  );
  const {
    userDetailsData,
    updatePasswordError,
    updatePhoneNumberSuccess,
    userDetailsError,
  } = useSelector((state) => state.loginUserDetails);

  const getUserDisplayId = () => {
    const fullUrl = window.location.href;
    console.log("Full URL:", fullUrl);

    const searchParams = new URLSearchParams(location.search);
    let id = searchParams.get("userDisplayId");
    console.log("ID from search params:", id);

    if (!id && location.hash) {
      const hashParts = location.hash.split("?");
      if (hashParts.length > 1) {
        const hashParams = new URLSearchParams(hashParts[1]);
        id = hashParams.get("userDisplayId");
        console.log("ID from hash params:", id);
      }
    }

    return id;
  };

  const userDisplayId = getUserDisplayId();

  const checkIsCreateAccount = () => {
    const pathHasCreateAccount = location.pathname.includes("create-account");
    const hashHasCreateAccount =
      location.hash && location.hash.includes("create-account");
    return pathHasCreateAccount || hashHasCreateAccount;
  };

  const isCreateAccount = checkIsCreateAccount();

  useEffect(() => {
    if (isCreateAccount) {
      console.log("Setting to create account mode");
      setIsLogin("create");
    } else if (locationData[1] === "login") {
      setIsLogin("login");
    } else {
      setIsLogin("create");
    }
  }, [location, isCreateAccount]);

  useEffect(() => {
    if (userDetailsData) {
      console.log("Received userDetailsData:", userDetailsData);
      setUserName(userDetailsData.username);
      setIsConfirmed(userDetailsData.confirmed);
      setFormKey(Date.now());

      setTimeout(() => {
        setIsConfirmed(false);
      }, 2000);

      if (userDetailsData.confirmed) {
        setIsAlreadyHaveAccount(true);
        navigateTo("/login");
        setIsLogin("login");
        setTimeout(() => {
          setIsAlreadyHaveAccount(false);
        }, 2000);
      }
    }
  }, [userDetailsData]);

  useEffect(() => {
    if (userDisplayId) {
      console.log("IMMEDIATE FETCH for userDisplayId:", userDisplayId);
      dispatch(fetchLoginUserDetails(userDisplayId));
    }
  }, [userDisplayId, dispatch]);

  useEffect(() => {
    if (isCreateAccount && userDisplayId) {
      console.log("Fetching user details for create account", userDisplayId);
      dispatch(fetchLoginUserDetails(userDisplayId)).catch((error) => {
        console.error("Error fetching user details:", error);
        setShowErrorAlert(true);
        setTimeout(() => {
          setShowErrorAlert(false);
        }, 2000);
      });
    }
  }, [location, userDisplayId, isCreateAccount, dispatch]);

  useEffect(() => {
    if (!isConfirmed && isLogin !== "login") {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }
  }, [isConfirmed, isLogin]);

  useEffect(() => {
    if (providerLoginAuth?.authorizationDTO?.token) {
      const authKey = providerLoginAuth?.authorizationDTO?.token;
      localStorage.setItem("auth-key", authKey);

      try {
        const tokenData = JSON.parse(atob(authKey.split(".")[1]));
        const userRoles = tokenData?.user?.grantedRoles || [];

        if (userRoles.includes("ROLE_PRACTICE")) {
          navigateTo("/my-practice");
        } else {
          navigateTo("/dashboard");
        }
      } catch (error) {
        console.log(error);
        setShowErrorAlert(true);
        setTimeout(() => {
          setShowErrorAlert(false);
        }, 2000);
        navigateTo("/dashboard");
      }

      window.location.reload();
    }
  }, [providerLoginAuth]);

  useEffect(() => {
    if (providerLoginSectionError || updatePasswordError) {
      setShowErrorAlert(true);
      setTimeout(() => {
        setShowErrorAlert(false);
      }, 2000);
    }
  }, [providerLoginSectionError, updatePasswordError]);

  useEffect(() => {
    if (
      isLogin !== "login" &&
      userDisplayId &&
      !userDetailsData?.username &&
      userDetailsError
    ) {
      setShowUsernameError(true);
      setTimeout(() => {
        setShowUsernameError(false);
      }, 2000);
    }
  }, [isLogin, userDisplayId, userDetailsData?.username, userDetailsError]);

  useEffect(() => {
    if (updatePhoneNumberSuccess && loginDetails && isLogin !== "login") {
      dispatch(fetchProviderAuthenticateWhileLogin(loginDetails));
    }
  }, [updatePhoneNumberSuccess, loginDetails, isLogin, dispatch]);

  const createAccountSchema = [
    {
      component: "input",
      label: "",
      type: "text",
      name: "userName",
      placeholder: "Email Address",
      defaultValue: userDetailsData?.username || userName || "",
      valueChangeCallback: () => {},
    },
    {
      component: "custom",
      customRender: () => (
        <div className="customLoginMsg">
          Your email will be used to log back into your account
        </div>
      ),
    },
    {
      component: "input",
      label: "",
      type: "password",
      name: "password",
      placeholder: "Enter Password",
      defaultValue: "",
      onKeyChangeCallback: (name, value) => {
        setNewPassword(value);
      },
      valueChangeCallback: () => {},
    },
    {
      component: "input",
      label: "",
      type: "password",
      name: "confirmPassword",
      placeholder: "Confirm Password",
      defaultValue: "",
      onKeyChangeCallback: (name, value) => {
        setConfirmPassword(value);
      },
      valueChangeCallback: () => {},
    },
    {
      component: "custom",
      customRender: () =>
        showError &&
        newPassword !== confirmPassword && (
          <p
            style={{
              fontSize: "12px",
              marginTop: "20px",
              color: "red",
              textAlign: "center",
            }}
          >
            Passwords do not match.
          </p>
        ),
    },
    {
      component: "custom",
      customRender: () => (
        <p
          style={{
            fontSize: "12px",
            marginTop: "20px",
            color: "#666",
          }}
        >
          By logging in, you are agreeing to the Brighter{" "}
          <a
            onClick={handleClick}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#0077b7",
              cursor: "pointer",
            }}
          >
            Terms and Condition
          </a>
        </p>
      ),
    },
  ];
  const handleClick = () => {
    window.open(providerTerms, "_blank");
  };

  const handleSubmitLogin = (value) => {
    if (isLogin !== "login" && newPassword !== confirmPassword) {
      setShowError(true);
      return;
    }
    setShowError(false);

    if (isLogin === "login") {
      if (!value.userName || !value.password) {
        return;
      }
    }

    const data = { ...value };
    data["X-DeviceFP"] = "d485dbc29097bda4b5bc5b8325f5af46f2b036be678";

    if (isLogin === "login") {
      const userName = value.userName;
      localStorage.setItem("userName", userName);
      setLoginDetails(data);
      dispatch(fetchProviderAuthenticateWhileLogin(data));
    }
    if (isLogin !== "login") {
      const data = {
        firstName: userDetailsData.firstName ? userDetailsData.firstName : "",
        lastName: userDetailsData?.lastName ? userDetailsData?.lastName : "",
        password: value?.password,
        username: userDetailsData.username,
      };
      dispatch(fetchUpdatePassword({ userId: userDisplayId, data }))
        .then(() => {
          const newData = { ...value };
          newData["X-DeviceFP"] = "d485dbc29097bda4b5bc5b8325f5af46f2b036be678";
          setLoginDetails(newData);
          dispatch(fetchProviderAuthenticateWhileLogin(newData));
        })
        .catch(() => {
          setShowErrorAlert(true);
          setTimeout(() => {
            setShowErrorAlert(false);
          }, 2000);
        });
    }
  };

  const RenderLoginForm = () => {
    return (
      <>
        <div className="top-wrap">
          <a id="logo-link">
            <img
              onClick={() => {
                const token = localStorage.getItem("auth-key");
                if (token) {
                  navigateTo("/dashboard");
                } else {
                  navigateTo("/home");
                }
              }}
              src={brighter}
              alt="login-logo"
            />
          </a>
        </div>
        <div>
          {providerLoginSectionError && (
            <div className="providerLoginSectionErrorWrapper">
              <div>
                <img
                  className="missing-data-img"
                  src={alertIcon}
                  alt="Missing Info Image"
                />
              </div>
              <div className="loginErrorDesc">
                {`The information provided does not match our records. If you do
                not know your password, please  `}
                <a
                  className="forgetPasswordLink"
                  onClick={() => {
                    navigateTo("/forgotPassword");
                  }}
                >
                  click here
                </a>
              </div>
            </div>
          )}
          {updatePasswordError && (
            <div className="alert alert-danger" role="alert">
              {updatePasswordError}
            </div>
          )}
          {showErrorAlert && (
            <div
              className="alert alert-danger alert-dismissible fade show"
              style={{
                position: "absolute",
                top: "32%",
                width: "94%",
                zIndex: 10000,
              }}
              role="alert"
            >
              Something went wrong. Please try again later.
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
                onClick={() => setShowErrorAlert(false)}
              ></button>
            </div>
          )}
        </div>
        <div id="login-left">
          <h2>
            {isLogin === "login"
              ? "Log into your account"
              : "Create Your Login"}
          </h2>
          <>
            {isAlreadyHaveAccount && (
              <div
                className="alert alert-danger alert-dismissible fade show"
                style={{
                  position: "absolute",
                  zIndex: "10000",
                  top: "23%",
                  width: "94%",
                }}
                role="alert"
              >
                You already have this account
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            )}
            {showAlert && userDisplayId && !showUsernameError && (
              <div
                className="alert alert-warning alert-dismissible fade show"
                style={{
                  position: "absolute",
                  top: "23%",
                  width: "94%",
                  zIndex: 10000,
                }}
                role="alert"
              >
                This account has not been confirmed yet. Please enter your
                details below.
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setShowAlert(false)}
                ></button>
              </div>
            )}
          </>
          <div className="login-form">
            <style>
              {`
                .red-text-input input {
                  color: #c13b3c !important;
                }
              `}
            </style>
            {
              <>
                {isLogin === "login" && !isCreateAccount ? (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      const formData = new FormData(e.target);
                      const data = Object.fromEntries(formData.entries());
                      handleSubmitLogin(data);
                    }}
                  >
                    <FloatingLabelInput
                      type="text"
                      name="userName"
                      placeholder="Email Address"
                      required={true}
                      className={!isEmailValid ? "red-text-input" : ""}
                      onKeyChangeCallback={(name, value) => {
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        setIsEmailValid(emailRegex.test(value) || value === "");
                      }}
                    />
                    <FloatingLabelInput
                      type="password"
                      name="password"
                      placeholder="Password"
                      required={true}
                      onKeyChangeCallback={(name, value) => {
                        setLoginPassword(value);
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "20px",
                        marginBottom: "40px",
                      }}
                    >
                      <button
                        type="submit"
                        className="saveBtn"
                        style={{
                          padding: "12px 32px",
                          width: "auto",
                        }}
                      >
                        Secure Login
                      </button>
                      <a
                        className="forget-password-link"
                        onClick={() => {
                          navigateTo("/forgotPassword");
                        }}
                      >
                        Forgot password?
                      </a>
                    </div>
                    <hr></hr>
                  </form>
                ) : (
                  <>
                    {userDetailsError && userDisplayId && !userDetailsData && (
                      <div className="alert alert-danger" role="alert">
                        Something went wrong. Please try again later.
                      </div>
                    )}
                    <>
                      <CgFormCreator
                        key={formKey}
                        schema={createAccountSchema}
                        enablePrimaryBtn={newPassword && confirmPassword}
                        onSubmitCallback={(value) => {
                          handleSubmitLogin(value);
                        }}
                        noCancel
                        primaryButton="login"
                      />
                    </>
                  </>
                )}
              </>
            }
          </div>
          {isLogin === "login" && (
            <div className="botton-wrap">
              <h2>New to Brighter?</h2>
              <p className="last">
                Access your free Brighter Profile today and grow your practice.
              </p>
              <p className="last">Provider questions? 424-316-2534</p>
            </div>
          )}
        </div>
      </>
    );
  };

  const RenderPinVerificationWindow = () => {
    if (
      providerLoginAuth?.requiresTwoFactorVerificationPhNumber ||
      providerLoginAuth?.requiresTwoFactorVerificationPhNumber === undefined
    )
      return null;

    return (
      <>
        <PinVerification
          loginDetails={loginDetails}
          providerLoginAuth={providerLoginAuth}
        />
      </>
    );
  };

  const RenderEnterPhoneNumber = () => {
    if (!providerLoginAuth?.requiresTwoFactorVerificationPhNumber) return null;

    return (
      <>
        <Mfa loginDetails={loginDetails} />
      </>
    );
  };

  return (
    <div className="Login-container">
      <div className="login-left-container">{RenderLoginForm()}</div>
      {RenderPinVerificationWindow()}
      {RenderEnterPhoneNumber()}
      <div className="login-right-container">
        <div className="login-content-right">
          <h2>Your login allows you to</h2>
          <ul>
            <li>
              <img src={whiteLock} alt="" />
              <p>
                Verify your information so patients
                <br />
                can reach you on provider directories.
              </p>
            </li>
            <li className="arrow-first">
              <img src={downwardArrow} alt="" />
            </li>
            <li>
              <img src={Practice013x} alt="" />
              <p>
                Highlight your technologies and
                <br />
                amenities to help your practice
                <br />
                stand out.
              </p>
            </li>
            <li className="arrow-last">
              <img src={downwardArrow} alt="" />
            </li>
            <li>
              <img src={whiteChat} alt="" />
              <p>
                Read the verified patient reviews we
                <br />
                have collected on your practice.
              </p>
            </li>
          </ul>
          <div className="bottom">
            <h6>Brighter powers Cigna&apos;s online provider directories.</h6>
            <img src={cignaLogo} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginFirst;
